module.exports = __webpack_public_path__ + "img/logo_zgyd.7b30473f.png";